import {
  GET_ORGANIZATIONS_FAIL,
  GET_ORGANIZATIONS_REQUEST,
  GET_ORGANIZATIONS_SUCCESS,
  GET_ORGANIZATIONS_CANCEL,
  REMOVE_ORGANIZATION,
  UPDATE_ORGANIZATION,
} from '../actions/organizations';

const initialState = {
  organizations: [],
  organizationsTotal: 0,
  organizationsAllTotal: 0,
  organizationsActiveTotal: 0,
  organizationsBlockedTotal: 0,
  organizationsLoading: false,
  organizationsError: false,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case GET_ORGANIZATIONS_REQUEST: {
      return {
        ...state,
        organizationsLoading: true,
        organizationsError: false,
      };
    }
    case GET_ORGANIZATIONS_SUCCESS: {
      return {
        ...state,
        organizations: action.payload.organizations,
        organizationsTotal: action.payload.total,
        organizationsAllTotal: state.organizationsAllTotal || action.payload.total,
        organizationsActiveTotal: state.organizationsActiveTotal || action.payload.total_active,
        organizationsBlockedTotal: state.organizationsBlockedTotal || action.payload.total_blocked,
        organizationsLoading: false,
        organizationsError: false,
      };
    }
    case GET_ORGANIZATIONS_FAIL: {
      return {
        ...state,
        organizationsLoading: false,
        organizationsError: true,
      };
    }
    case GET_ORGANIZATIONS_CANCEL: {
      return {
        ...state,
        organizationsLoading: false,
        organizationsError: false,
      };
    }
    case UPDATE_ORGANIZATION: {
      const newOrganizations = state.organizations.map(
        (item) => (item._id === action.payload._id ? Object.assign(item, action.payload) : item),
      );
      return {
        ...state,
        organizationsLoading: false,
        organizationsError: true,
        organizations: newOrganizations,
      };
    }
    case REMOVE_ORGANIZATION: {
      const newOrganizations = state.organizations.filter((item) => item._id !== action.payload._id);
      return {
        ...state,
        organizationsLoading: false,
        organizationsError: true,
        organizations: newOrganizations,
      };
    }

    default: {
      return state;
    }
  }
}
